import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { PermissionSetType } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { useUserPermissionSetType } from 'hooks/permissions';
import { useIsKnowledgeBaseFeatureEnabled } from 'hooks/use-knowledge-base-feature';
import { useIsScarletFeatureEnabled } from 'hooks/use-scarlet-feature';
import { NotFound } from 'routes/404';
export const ScarletFeatureWrapper = ({ children })=>{
    const isScarletEnabled = useIsScarletFeatureEnabled();
    if (!isScarletEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
        children: children
    });
};
export const KnowledgeBaseFeatureWrapper = ({ children })=>{
    const isKnowledgeBaseEnabled = useIsKnowledgeBaseFeatureEnabled();
    const currentUserPermissionSetType = useUserPermissionSetType();
    const isAccountAdmin = currentUserPermissionSetType === PermissionSetType.AccountAdmin;
    if (!isKnowledgeBaseEnabled || !isAccountAdmin) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
        children: children
    });
};
